import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import { DEVICES } from 'utils';

import StatusCellTableDesktop from './StatusCellTableDesktop';
import StatusCellTableMobile from './StatusCellTableMobile';

interface StatusCellTableProps {
  status: number;
  name?: string;
}

const StatusCellTable = (props: StatusCellTableProps): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);

  const renderElements = {
    [DEVICES.DESKTOP]: <StatusCellTableDesktop {...props} />,
    [DEVICES.MOBILE]: <StatusCellTableMobile {...props} />,
    [DEVICES.TABLET]: <StatusCellTableMobile {...props} />,
  };

  return renderElements[appDevice.device];
};

export default StatusCellTable;
